import { Grid, Typography } from "@mui/material";
import { useSuperAdminSingleSuscrip } from "../../../context/SuperAdmin/SingleSuscriptContext";

const TitleUserSuscription = () => {
  const { plan, suscripcion } = useSuperAdminSingleSuscrip();
  return (
    <Grid
      item
      spacing={2}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      {/* Título */}
      <Grid item>
        <Typography variant={"h4"} sx={{ color: "#005559", fontSize: "30px" }}>
          <b>Suscripción</b> | {plan.nombre}
        </Typography>
      </Grid>

      {/* Estado de suscripción como tag */}
      <Grid item>
        <Typography
          component="span"
          sx={{
            fontSize: "1.1rem",
            fontWeight: "bold",
            backgroundColor: "#336B87", // Azul claro de tu paleta
            color: "#FFFFFF", // Texto blanco para contraste
            borderRadius: "8px",
            paddingX: "12px",
            paddingY: "4px",
            display: "inline-block",
          }}
        >
          {suscripcion.estado}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default TitleUserSuscription;
